/*eslint-disable*/
import React from 'react'
import { Formik, Field as Fieldmik, yupToFormErrors } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';

import { MyInput, MyTextArea } from '../../formikInput/input';
import TdsSectionDropdown from '../../dropdowns/tdsSectionDropdown';
import { SACCodeMessages, HSNCodeMessages } from '../../../utils/constant';

const AddProductModal = ({ handleCloseAdd, createExpense, ...props }) => {

    const initialValues = {
        expenseName: '',
        expenseCode: '',
        expenseCategory: '',
        gst: '',
        tds: '',
        description: '',
        SACCode: null,
        HSNCode: null,
        psLineItemGLCode:''
    }

    const validateSchema = yup.object().shape({
        expenseCode: yup.string().required('Expense Code Required'),
        expenseName: yup.string().required('Expense Name Required'),
        SACCode: yup.number("Should be a number").min(1000, SACCodeMessages.SAC_CODE_MIN).max(99999999, SACCodeMessages.SAC_CODE_MAX).nullable(),
        HSNCode: yup.number("Should be a number").min(10, HSNCodeMessages.HSN_CODE_MIN).max(999999, HSNCodeMessages.HSN_CODE_MAX).nullable(),
    })

    const onSubmit = (values, onSubmitProps) => {

        let expenseData = {
            customerNumber: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            psDescription: values.expenseName,
            categoryId: values.expenseCategory,
            psType: "1",
            psCode: values.expenseCode,
            sellingPrice: values.price,
            purchasePrice: values.price,
            gstPercentage: values.gst,
            sellingDesc: '',
            purchaseDesc: values.description,
            openingStock: '200',
            height: '12',
            width: '12',
            length: '12',
            SACCode: values.SACCode,
            HSNCode: values.HSNCode,
            psLineItemGLCode:values.psLineItemGLCode
        }
        createExpense(expenseData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });

    }

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, errors, touched, handleSubmit }) => (
                    <>
                        <Modal.Content>
                            <Container>
                                <div className="ui form tiny">
                                    <FormUi.Group>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">Product Name *</label>
                                            <Fieldmik name="expenseName" component={MyInput} error={values.expenseName ? false : true} placeholder="Enter Name" />
                                            {touched.expenseName && errors.expenseName ? <Label size="mini" prompt pointing>{errors.expenseName}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width='8'>
                                            <label className="labelName p-bold-600">Product Code *</label>
                                            <Fieldmik name="expenseCode" component={MyInput} error={values.expenseCode ? false : true} placeholder="Enter Code" />
                                            {touched.expenseCode && errors.expenseCode ? <Label size="mini" prompt pointing>{errors.expenseCode}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">Product / Service Category *</label>
                                            <Fieldmik name="expenseCategory" component={MyInput} error={values.expenseCategory ? false : true} placeholder="Select Category" />
                                            {touched.expenseCategory && errors.expenseCategory ? <Label size="mini" prompt pointing>{errors.expenseCategory}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">GST *</label>
                                            <Fieldmik name="gst" component={MyInput} error={values.gst ? false : true} placeholder="Enter GST" />
                                            {touched.gst && errors.gst ? <Label size="mini" prompt pointing>{errors.gst}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>

                                        <FormUi.Field width='8'>
                                            <label className="labelName p-bold-600">TDS *</label>
                                            <Fieldmik name="tds" component={TdsSectionDropdown} error={values.tds ? false : true} placeholder="Enter TDS" />
                                            {touched.tds && errors.tds ? <Label size="mini" prompt pointing>{errors.tds}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">GL Code</label>
                                            <Fieldmik name="psLineItemGLCode" component={MyInput}  placeholder="Enter GL Code" />
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">SAC Code *</label>
                                            <Fieldmik name="SACCode" type="number" placeholder="Enter SAC Code" />
                                            {touched.SACCode && errors.SACCode ? <Label size="mini" prompt pointing>{errors.SACCode}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="8">
                                            <label className="labelName p-bold-600">HSN Code *</label>
                                            <Fieldmik name="HSNCode" type="number" placeholder="Enter HSN Code" />
                                            {touched.HSNCode && errors.HSNCode ? <Label size="mini" prompt pointing>{errors.HSNCode}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group>
                                        <FormUi.Field width="16">
                                            <label className="labelName p-bold-600">Description *</label>
                                            <Fieldmik name="description" component={MyTextArea} error={values.description ? false : true} placeholder="Enter Description" />
                                            {touched.description && errors.description ? <Label size="mini" prompt pointing>{errors.description}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                </div>
                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={handleCloseAdd} size="mini">Cancel</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>Submit</Button>
                        </Modal.Actions>
                    </>
                )}
            </Formik>
        </>
    )
}


export default AddProductModal
